import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import HeaderComponent from '../HeaderComponent';

import { formatNumber, formatLargeNumber } from '../../service/market';

import css from '../../styles/instrument/estimates';

class Estimates extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        CURRENCY: PropTypes.string,
        BASE_Y: PropTypes.number,
        TOTAL_SHARES: PropTypes.number,
        MARKET_CAP_SALES_Y: PropTypes.number,
        MARKET_CAP_SALES_YM1: PropTypes.number,
        MARKET_CAP_SALES_YP1: PropTypes.number,
        P_E_Y: PropTypes.number,
        P_E_YM1: PropTypes.number,
        P_E_YP1: PropTypes.number,
        MEDIAN_EPS_Y: PropTypes.number,
        MEDIAN_EPS_YM1: PropTypes.number,
        MEDIAN_EPS_YP1: PropTypes.number,
        MEDIAN_NET_ASSETS_Y: PropTypes.number,
        MEDIAN_NET_ASSETS_YM1: PropTypes.number,
        MEDIAN_NET_ASSETS_YP1: PropTypes.number,
        MEDIAN_SALES_Y: PropTypes.number,
        MEDIAN_SALES_YM1: PropTypes.number,
        MEDIAN_SALES_YP1: PropTypes.number,
        EBITDA_MEDIAN_Y: PropTypes.number,
        EBITDA_MEDIAN_YM1: PropTypes.number,
        EBITDA_MEDIAN_YP1: PropTypes.number,
        ENTERPRISE_VALUE_Y: PropTypes.number,
        ENTERPRISE_VALUE_YM1: PropTypes.number,
        ENTERPRISE_VALUE_YP1: PropTypes.number,
    }

    constructor(props) {
        super(props);

        this.state = {
            selectedInterval: 'YP1',
            years: {},
        };

        this._updateInterval = (e) => {
            e.target.blur();
            this.setState({ selectedInterval: e.target.value });
        };

        this._renderProp = prop => formatNumber(this.props[prop]);

        this._renderMillion = prop => {
            const value = this.props[prop];

            if (!isFinite(value)) {
                return '-';
            }

            return formatLargeNumber(value * 1e6);
        };

        this._renderEquityCapital = prop => {
            const { TOTAL_SHARES } = this.props;
            const netAssets = this.props[prop];

            if (!netAssets || !TOTAL_SHARES) {
                return '-';
            }

            const value = netAssets * (TOTAL_SHARES * 1000000);

            return formatLargeNumber(value);
        };
    }

    componentWillReceiveProps(nextProps) {
        const { BASE_Y } = nextProps;

        this.setState({
            years: {
                YP1: BASE_Y + 1,
                Y: BASE_Y,
                YM1: BASE_Y - 1,
            },
        });
    }

    renderYear() {
        const { years, selectedInterval } = this.state;

        return years[selectedInterval] || 'SEK';
    }

    renderButtons() {
        const { years, selectedInterval } = this.state;

        return (
            <div className={css.buttons}>
                {Object.keys(years).map(year => {
                    const classNames = [css.button];
                    if (selectedInterval === year) {
                        classNames.push(css.tabSelected);
                    }

                    return (<button
                        key={year}
                        className={classNames.join(' ')}
                        onClick={this._updateInterval}
                        value={year}
                    >{years[year]}</button>);
                })
            }
            </div>
        );
    }

    renderFields() {
        const { selectedInterval } = this.state;
        const { t } = this.props;

        const rows = [];
        const estimates = [
            [t('estimates.ps'), 'MARKET_CAP_SALES_', this._renderProp],
            [t('estimates.pe'), 'P_E_', this._renderProp],
            [t('estimates.eps'), 'MEDIAN_EPS_', this._renderProp],
            [t('estimates.equityPerShare'), 'MEDIAN_NET_ASSETS_', this._renderProp],
            [t('estimates.totalEquity'), 'MEDIAN_NET_ASSETS_', this._renderEquityCapital],
            [t('estimates.sales'), 'MEDIAN_SALES_', this._renderMillion],
            [t('estimates.ebitda'), 'EBITDA_MEDIAN_', this._renderMillion],
            [t('estimates.enterpriseValue'), 'ENTERPRISE_VALUE_', this._renderMillion],
        ];

        for (const [name, prop, handler] of estimates) {
            rows.push(
                <tr className={css.tableRow} key={name}>
                    <td className={css.name}>{name}</td>
                    <td className={css.value}>{handler(`${prop}${selectedInterval}`)}</td>
                </tr>
            );
        }

        return rows;
    }

    render() {
        if (!this.props.BASE_Y) {
            return null;
        }

        const { t } = this.props;

        return (
            <HeaderComponent
                title={t('estimates.title')}
                titleAddition={this.props.CURRENCY}
                buttonGroup={this.renderButtons()}
            >
                <div className={css.tableWrapper}>
                    <table className={css.table}>
                        <thead className={css.thead}>
                            <tr>
                                <th colSpan={2}>{this.renderYear()}</th>
                            </tr>
                        </thead>
                        <tbody>
                            { this.renderFields() }
                        </tbody>
                    </table>
                </div>
            </HeaderComponent>
        );
    }
}

export default translate('stocks')(Estimates);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/Estimates.js
 **/